/** @format */

import { fractionsConstants } from './actions';
import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export type fractionsReducerType = {
    type: string;
    message: string;
    collections?: any;
    success: boolean;
    data: any;
    item: any;
};

export function fractionsReducers(state = {}, action: fractionsReducerType): object {
    reducerDebug('Fractions reducer: ' + action.type);
    switch (action.type) {
        case fractionsConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case fractionsConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case fractionsConstants.ADD:
        case fractionsConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case fractionsConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
                success: false,
                deletedSuccess: false,
            };
    }
}
